import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/api/client";
import type { User } from "@/api/types";

interface AuthCtx {
  user: User | null | undefined; // undefined = checking
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, fullName: string) => Promise<void>;
  logout: () => Promise<void>;
}

const Ctx = createContext<AuthCtx>({} as AuthCtx);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null | undefined>(undefined);

  const refresh = useCallback(async () => {
    try {
      const u = await api.me();
      setUser(u);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email: string, password: string) => {
    await api.login(email, password);
    setUser(await api.me());
  };
  const register = async (email: string, password: string, fullName: string) => {
    await api.register(email, password, fullName);
    setUser(await api.me());
  };
  const logout = async () => {
    await api.logout();
    setUser(null);
  };

  return <Ctx.Provider value={{ user, login, register, logout }}>{children}</Ctx.Provider>;
};

export const useAuth = () => useContext(Ctx);
